module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-01-2d5811e2.jpg";